module.exports = __webpack_public_path__ + "img/home_header_bg@2x.c61f2bd2.png";